export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("./views/LoginView.vue"),
    props: true
  },
// {
  //   path: "/login-public",
  //   name: "LoginPublic",
  //   component: () => import("./views/LoginViewPublic.vue"),
  //   props: true
  // },
  {
    path: "/login/forget-password",
    name: "LoginForgetPassword",
    component: () => import("./views/LoginForgetPasswordView.vue"),
    props: true
  },
  {
    path: "/login/forget-cps-password",
    name: "LoginForgetCPSPassword",
    component: () => import("./views/LoginForgetCPSPasswordView.vue"),
    props: true
  },
  {
    path: "/login/forget-certification",
    name: "LoginForgetCertification",
    component: () => import("./views/LoginForgetCertificationView.vue"),
    props: true
  },
  {
    path: "/login/forget-login-name",
    name: "LoginForgetLoginName",
    component: () => import("./views/LoginForgetLoginNameView.vue"),
    props: true
  },
  {
    path: "/login-bd",
    name: "LoginBd",
    component: () => import("./views/LoginBdView.vue") // remove soon
  },
  {
    path: "/login-cps",
    name: "LoginCps",
    component: () => import("./views/LoginCpsView.vue")
  },
  {
    path: "/login/iam-smart/pending",
    name: "LoginIAMSmartPendingView",
    component: () => import("./views/LoginIAMSmartPendingView.vue"),
    props(route) {
      return {
        businessId: route.query["business-id"]
      };
    }
  },
  // {
  //   path: "/login-public/iam-smart/pending-public",
  //   name: "LoginIAMSmartPublicMemberPendingView",
  //   component: () => import("./views/LoginIAMSmartPublicMemberPendingView.vue"),
  //   props(route) {
  //     return {
  //       businessId: route.query["business-id"]
  //     };
  //   }
  // },
  {
    path: "/login/iam-smart/invitation",
    name: "LoginIAMSmartInvitationView",
    component: () => import("./views/LoginIAMSmartInvitationView.vue"),
    props(route) {
      return {
        businessId: route.query["business-id"]
      };
    }
  },
  {
    path: "/login-cps/invitation",
    name: "LoginCPSInvitationView",
    component: () => import("./views/LoginCPSInvitationView.vue"),
    props(route) {
      return {
        businessId: route.query["business-id"]
      };
    }
  },
  {
    path: "/login/set-password/activation-key",
    name: "LoginActivationKeyView",
    component: () => import("./views/LoginActivationKeyView.vue")
  },
  {
    path: "/login/set-password/cps-activation-key",
    name: "LoginCPSActivationKeyView",
    component: () => import("./views/LoginCPSActivationKeyView.vue")
  },
  {
    path: "/login/reset-certification/activation-key",
    name: "LoginCertificationActivationKeyView",
    component: () => import("./views/LoginCertificationActivationKeyView.vue")
  },
  {
    path:"/login/e-drive",
    name: "LoginEDriveView",
    component: () => import("./views/LoginEDriveView.vue")
  }
];
